import { useTranslation } from 'react-i18next';
import { usePlatformContext } from 'routes/platform.context';
import { Button } from 'common/components';
import { Container } from './styles';

const Footer = () => {
    const { t } = useTranslation();
    const { platform } = usePlatformContext();

    return (
        <Container>
            {!!platform?.termsOfService && (
                <Button
                    onClick={() => {
                        window.open(platform.termsOfService, '_blank');
                    }}
                    size='small'
                    variant='text'
                    color='primary'
                >
                    {t('term.use-terms')}
                </Button>
            )}
            {!!platform?.privacyPolicyUrl && (
                <Button
                    onClick={() => window.open(platform?.privacyPolicyUrl, '_blank')}
                    size='small'
                    variant='text'
                    color='primary'
                >
                    {t('shared.pages.menu-header.option.privacy-policy')}
                </Button>
            )}
        </Container>
    );
};

export default Footer;
